import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Lock, Zap } from 'lucide-react';
// --- Geo-based pricing ---
interface PriceData {
  oldPrice: string;
  newPrice: string;
  savings: string;
  ctaPrice: string;
}
const PRICES: Record<string, PriceData> = {
  MX: {
    oldPrice: 'MXN $280',
    newPrice: 'MXN $130',
    savings: 'AHORRAS MXN $150',
    ctaPrice: '$130 MXN'
  },
  CO: {
    oldPrice: 'COP $61,000',
    newPrice: 'COP $28,000',
    savings: 'AHORRAS COP $33,000',
    ctaPrice: '$28,000 COP'
  },
  AR: {
    oldPrice: 'ARS $19,999',
    newPrice: 'ARS $6,500',
    savings: 'AHORRAS ARS $13,499',
    ctaPrice: '$6,500 ARS'
  },
  CL: {
    oldPrice: 'CLP $14,600',
    newPrice: 'CLP $6,500',
    savings: 'AHORRAS CLP $8,100',
    ctaPrice: '$6,500 CLP'
  },
  PE: {
    oldPrice: 'S/ 54.99',
    newPrice: 'S/ 26.00',
    savings: 'AHORRAS S/ 28.99',
    ctaPrice: 'S/ 26.00'
  },
  DEFAULT: {
    oldPrice: 'USD $97',
    newPrice: 'USD $6.95',
    savings: 'AHORRAS USD $90.05',
    ctaPrice: '$6.95 USD'
  }
};
const EU_COUNTRIES = ['AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE'];
const EU_PRICE: PriceData = {
  oldPrice: '€13.00',
  newPrice: '€6.50',
  savings: 'AHORRAS €6.50',
  ctaPrice: '€6.50'
};
function useGeoPrice() {
  const [price, setPrice] = useState<PriceData>(PRICES.DEFAULT);
  useEffect(() => {
    fetch('https://get.geojs.io/v1/ip/country.json').then(r => r.json()).then(d => {
      const c = (d.country || '').toUpperCase();
      if (EU_COUNTRIES.includes(c)) setPrice(EU_PRICE);else setPrice(PRICES[c] || PRICES.DEFAULT);
    }).catch(() => setPrice(PRICES.DEFAULT));
  }, []);
  return price;
}
function CountdownTimer() {
  const [timeLeft, setTimeLeft] = useState(29 * 60 + 47);
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => setTimeLeft(t => Math.max(0, t - 1)), 1000);
    return () => clearInterval(interval);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  return <div className="flex items-center justify-center gap-2 bg-[var(--red-emphasis)]/15 border border-[var(--red-emphasis)]/30 rounded-lg px-3 py-2 mb-4" data-id="element-111">
      <Zap className="w-3.5 h-3.5 text-[var(--red-emphasis)] fill-current flex-shrink-0" data-id="element-112" />
      <span className="text-xs text-[var(--text-primary)]" data-id="element-113">Expira en:</span>
      <div className="flex items-center gap-1 font-mono font-bold text-[var(--red-emphasis)] text-base" data-id="element-114">
        <span className="bg-[var(--red-emphasis)]/20 px-1.5 py-0.5 rounded" data-id="element-115">
          {pad(minutes)}
        </span>
        <span className="animate-pulse" data-id="element-116">:</span>
        <span className="bg-[var(--red-emphasis)]/20 px-1.5 py-0.5 rounded" data-id="element-117">
          {pad(seconds)}
        </span>
      </div>
    </div>;
}
const bonuses = [{
  label: 'Manual Completo: Plan B Migratorio',
  value: '$47',
  image: 'https://cdn.magicpatterns.com/uploads/3n4ds5BYVTxsq9t4FEGGRH/cover_2.png'
}, {
  label: 'Bono #1 — Checklist FBI/Apostilla',
  value: '$17',
  image: 'https://cdn.magicpatterns.com/uploads/uhLWM1JGhFCwioEgwKr8mA/1.png'
}, {
  label: 'Bono #2 — Guía Bancaria Anti-Bloqueo',
  value: '$17',
  image: 'https://cdn.magicpatterns.com/uploads/wiWCXRqeJFZwywy4CCeeHF/2.png'
}, {
  label: 'Bono #3 — Matriz de Costos + Plan 90 Días',
  value: '$16',
  image: 'https://cdn.magicpatterns.com/uploads/6msJJKZkXy3iUxeCqMGhQC/3.png'
}];
export function CTASection() {
  const price = useGeoPrice();
  const handleBuy = () => {
    if (typeof (window as any).fbq === 'function') {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'Plan B Migratorio',
        content_type: 'product',
        value: 6.95,
        currency: 'USD'
      });
    }
    window.open('https://www.simplementemejor.com/cart/51755419697432:1', '_blank');
  };
  return <section id="cta-section" className="py-8 md:py-10 px-4 md:px-6 bg-[var(--bg-deep)] relative overflow-hidden" data-id="element-118">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(circle, rgba(212,136,58,0.06) 0%, transparent 70%)'
    }} data-id="element-119" />

      <div className="max-w-[520px] mx-auto relative z-10" data-id="element-120">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[var(--bg-card)] border border-[var(--accent)]/25 p-4 md:p-6 rounded-xl text-center shadow-[0_4px_40px_rgba(0,0,0,0.08)]" data-id="element-121">
          <p className="text-[var(--accent)] uppercase tracking-widest text-[10px] font-bold mb-1" data-id="element-122">
            Oferta Especial
          </p>
          <h2 className="text-xl md:text-3xl font-serif text-[var(--text-heading)] mb-1" data-id="element-123">
            Activa tu Plan B hoy
          </h2>
          <p className="text-[var(--text-muted)] mb-3 font-light text-[10px] md:text-xs" data-id="element-124">
            Manual completo · descarga inmediata
          </p>

          <CountdownTimer data-id="element-125" />

          {/* Price */}
          <div className="flex items-baseline justify-center gap-3 mb-1" data-id="element-126">
            <span className="text-base text-[var(--text-muted)] line-through opacity-60" data-id="element-127">
              {'USD $35'}
            </span>
            <span className="text-4xl font-serif font-bold text-[var(--accent)]" data-id="element-128">
              {price.newPrice}
            </span>
          </div>
          <div className="inline-block bg-gradient-to-r from-[var(--accent)] to-[#e8a04c] text-[#110608] px-3 py-0.5 rounded-full text-[10px] font-bold uppercase tracking-wider mb-3" data-id="element-129">
            {'AHORRAS USD $28.05'}
          </div>

          {/* CTA Button */}
          <motion.button onClick={handleBuy} whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} animate={{
          boxShadow: ['0 0 0 0 rgba(212,136,58,0)', '0 0 40px 12px rgba(212,136,58,0.4)', '0 0 0 0 rgba(212,136,58,0)']
        }} transition={{
          boxShadow: {
            duration: 2,
            repeat: Infinity,
            ease: 'easeInOut'
          }
        }} className="relative w-full py-4 bg-gradient-to-r from-[var(--accent)] to-[#e8a04c] text-[#110608] font-extrabold text-base md:text-lg rounded-lg shadow-lg overflow-hidden group cursor-pointer mb-3 whitespace-nowrap" data-id="element-130">
            <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/30 to-transparent" data-id="element-131" />
            <span className="relative flex items-center justify-center gap-2" data-id="element-132">
              <Lock className="w-4 h-4 md:w-5 md:h-5 flex-shrink-0" data-id="element-133" />
              ACTIVAR MI PLAN B — {price.ctaPrice}
            </span>
          </motion.button>

          {/* Trust badges + guarantee — merged compact */}
          <div className="flex items-center justify-center gap-3 text-[10px] text-[var(--text-muted)] mb-3 flex-wrap" data-id="element-134">
            <span className="flex items-center gap-1" data-id="element-135">
              <Lock className="w-3 h-3" data-id="element-136" /> Pago Seguro
            </span>
            <span className="opacity-30" data-id="element-137">|</span>
            <span className="flex items-center gap-1" data-id="element-138">
              <Zap className="w-3 h-3" data-id="element-139" /> Inmediata
            </span>
            <span className="opacity-30" data-id="element-140">|</span>
            <span className="flex items-center gap-1" data-id="element-141">
              <ShieldCheck className="w-3 h-3" data-id="element-142" /> Garantía 30 días
            </span>
          </div>

          {/* Guarantee — compact */}
          <div className="border border-[var(--accent)]/15 bg-[var(--accent)]/5 rounded-lg p-3" data-id="element-143">
            <p className="text-[11px] text-[var(--text-muted)] leading-relaxed" data-id="element-144">
              <ShieldCheck className="w-3.5 h-3.5 text-[var(--accent)] inline mr-1 -mt-0.5" data-id="element-145" />
              <strong className="text-[var(--text-heading)]" data-id="element-146">
                Garantía 30 días:
              </strong>{' '}
              Si no te ayuda, pides reembolso. Sin preguntas.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}